import { useLayoutEffect, useRef } from "react";

// Uses useLayoutEffect to run BEFORE useClearUrlOnTerminalChange,
// preventing race conditions where URL changes would be immediately cleared
export const useUrlToGlobalTerminalSync = (
  urlSelectedTerminalId: number | null,
  globalTerminalId: number | undefined,
  setGlobalTerminalId: (data: { terminal_id: number[] }) => void,
  isApplyingUrlTerminal: React.MutableRefObject<boolean>,
  hasTerminalMismatch: boolean
) => {
  const prevUrlIdRef = useRef<number | null>(null);

  useLayoutEffect(() => {
    const urlChanged = prevUrlIdRef.current !== urlSelectedTerminalId;

    if (globalTerminalId !== undefined) {
      prevUrlIdRef.current = urlSelectedTerminalId;

      if (urlChanged && hasTerminalMismatch) {
        isApplyingUrlTerminal.current = true;
        setGlobalTerminalId({ terminal_id: [urlSelectedTerminalId] });
      }
    }
  }, [urlSelectedTerminalId, globalTerminalId, setGlobalTerminalId, isApplyingUrlTerminal]);
};
